import { addDutchTelFormatting } from './utils';

export const getSlugItem = <
  T extends {
    name: string | undefined;
    slug: string;
  },
>(
  array: T[],
  slug: string
): T | undefined => array.find((item) => item.slug === slug);

export function getBlogSlugFromURL(): string | null {
  const path: string = window.location.pathname;
  const parts: string[] = path.split('/');

  if (parts.length >= 2) {
    return parts[parts.length - 1];
  }
  return null;
}

export function redirect(url: string): void {
  window.location.href = url;
}

export function getWhatsAppLink(number: string): string {
  return `https://api.whatsapp.com/send/?phone=${addDutchTelFormatting(number)}&text&type=phone_number&app_absent=0`;
}

export function openInNewTab(url: string) {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
}

export function pushValueInQuery(url: string, key: string, value?: string) {
  const queryPart = url.split('?');
  const query =
    queryPart.length > 1
      ? queryPart[1].split('&').map((m) => {
          const pair = m.split('=');
          return { key: pair[0], value: pair[1] };
        })
      : [];

  if (value !== undefined && query.every((q) => q.key != key)) {
    query.push({ key: 'c', value: value });
  }

  var queryString = query.map((m) => `${m.key}=${m.value}`).join('&');

  return queryString.length > 0 ? `${queryPart[0]}?${queryString}` : url;
}
